import { CircularProgress, Grid, Button } from '@material-ui/core/';
import React, { FC } from 'react';
import styled from 'styled-components';
import ProductCard from 'components/SalesArea/pages/ProductList/ProductCard';
import {
  CollectionFragmentFragment,
  Product,
  ProductVariant,
} from 'graphql/shopify-store-front-api/queries/types';

export type Props = {
  /**
   * ページ切り替えに使用する関数
   */
  pagingFunction: VoidFunction;

  /**
   * 表示するコレクション情報
   */
  collection: CollectionFragmentFragment | undefined;

  /**
   * ローディング中であるかを示す真偽値
   */
  isLoading: boolean;
};

const StyledGrid = styled.div`
  margin: 5%;
`;
const StyledCard = styled.div`
  margin: 10px;
`;

/**
 * 販売商品を表示するコンポーネント
 */
const ProductsList: FC<Props> = ({ pagingFunction, collection, isLoading }) => (
  <>
    <StyledGrid>
      <Grid container justify="center">
        {isLoading ? (
          <CircularProgress />
        ) : (
          collection &&
          collection.products.edges.map((product) => {
            return product.node.variants.edges.map((variant) => (
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <StyledCard>
                  <ProductCard
                    key={variant.node.id}
                    product={product.node as Product}
                    variant={variant.node as ProductVariant}
                  />
                </StyledCard>
              </Grid>
            ));
          })
        )}
        <Grid container justify="center">
          <Button
            variant="contained"
            color="primary"
            onClick={() => pagingFunction()}
          >
            カートを確認
          </Button>
        </Grid>
      </Grid>
    </StyledGrid>
  </>
);

export default ProductsList;
